<template>
	<div class="bg-secondary  ">
		<nav class="navbar navbar-expand-lg navbar-dark bg-dark static-top">
			<div class="container">
				<a href="https://www.mallaventura.com">
					<img src="@/assets/logo.png"
   						class="img-brand"
   						alt />
				</a>
				<div class id="navbarSupportedContent">
					<div class="col-md-12 text-right">
						<h6 class="text-white font-Atencion">Horario de atención:</h6>
						<h6 class="text-white font-Atencion">LUN-SAB | 10 am a 7pm</h6>
					</div>
				</div>
			</div>
		</nav>
		<div class="container  bg-white my-2 p-5   ">
			<div class="text-center  ">
				<br/>
				<b>MALL AVENTURA AREQUIPA</b>
				<br/>(TERMINOS Y CONDICIONES DE USO)
				<br/>
				<br/>
			</div>
			<div class="text-justify mx-2">
				<p>
					Los presentes Términos y Condiciones de Uso regulan el servicio de
					“Personal Shopper o asesor de compras” (en adelante “EL SERVICIO”),
					brindado por el Mall Aventura Arequipa (en adelante, “MALL AVENTURA
					AREQUIPA”), operado por MALL AVENTURA S.A. en alianza con el señor
					JOSÉ TEODORO SALAZAR MOLINA (en adelante, JTSM).
				</p>
				<p>
					Las personas (ya sean naturales o jurídicas) que acepten utilizar EL
					SERVICIO serán identificadas en estos Términos y Condiciones de uso
					como “Usuario”, ya sea en singular o plural.
				</p>
				<p>
					El Usuario declara haber leído cuidadosamente estos Términos y
					Condiciones de Uso, y tener conocimiento de los mismos, para lo cual
					se le solicitará al Usuario dar su expresa conformidad, previo a la
					contratación de EL SERVICIO. LIPPI, QUIKSILVER, FOOTLOSE, BATA, VIALE,
					PLATANITOS, BATA WOMAN, OJEDA, PAYLESS SHOES, CALIMOD, RENZO COSTA
					CALZADO, DC, AZALEIA, KELLYS SHOES, JETSET, HUSH PUPPIES, CROCS, TM
					ACCESORIOS, BE SIFRAH, ISADORA, MOIRAS, KAYSER, TEXTILON, RENZO COSTA,
					PORTA PRO, OCEANO MOCHILAS, TIZZA, QUALITY STORE, TAI LOY, GMO, VISION
					CENTER, ECONOPTICAS, SUNGLASS HUT, SUN TIME STORE, ESIKA, MIFARMA,
					INKAFARMA, CRISOL, LA IBERICA, PRO NUTRITION, HEALTH ONE, LEXUS KIDS,
					H&M, ESTILOS, CASA & IDEAS, TOPITOP, MAMUT MODULO, , PREMIER DEAD SEA,
					JOYERIA MUÑOZ NAJAR, VIVE MEXICO MODULO, MEGA PHONE MODULO, MAYBELLINE
					MODULO, CHRONOS MODULO, ARTEM COLLECTION, EF PERFUMES MODULO, MAC
					COSMETICOS, PERFUMES FACTORY, FRANCISCA F.O, RIPLEY, SAGA, SODIMAC.
				</p>
			</div>
			<b>I. ¿Qué es Personal Shopper o asesor de compras de Mall Aventura
				Arequipa?</b>
			<br/>
			<br/>
			<div class="text-justify mx-2">
				<p>
					A través de EL SERVICIO el Usuario podrá realizar compras en
					diferentes tiendas de Mall Aventura Arequipa, contactándose a través
					de WhatsApp con un “asesor de compras”, quien se encargará de buscar y
					comprar -por encargo del Usuario- el producto que desee adquirir,
					siempre que éste haya sido íntegramente cancelado por el Usuario.
				</p>
				<p>
					EL SERVICIO incluye la entrega del producto al domicilio que sea
					indicado por el Usuario.
				</p>
				<p>
					Lugar y horario de EL SERVICIO: EL SERVICIO se prestará vía WhatsApp y
					las compras de los productos se realizarán en el Centro Comercial Mall
					Aventura Arequipa, ubicado en la Av. Porongoche No. 500, Paucarpata,
					del Departamento de Arequipa, en el siguiente horario: De lunes a
					sábado (incluidos feriados), desde las 11:00am hasta las 8:00pm. Los
					días domingo solo se realizarán las publicaciones de las SHOPPERS en
					las redes sociales.
				</p>
				<p>
					Zonas de delivery: José Luis Bustamante, Mariano Melgar, Distrito
					Arequipa, Miraflores, Yanahuara, Jacobo Hunter, Socabaya, Paucarpata,
					Characato, Selva Alegre, Cerro Colorado - Av. Ejército, Cerro Colorado
					– Pachacutec, Cayma y Sachaca.
				</p>
				<p>
					Costo: EL SERVICIO será gratuito para el usuario, debiendo asumir
					únicamente el costo del delivery, según el distrito de su domicilio y
					tarifario de Taxitel.
				</p>
				<p>
					Tiendas participantes: KIDSMADEHERE, ESSENTIEL, MALOKO MODA Y
					ACCESORIOS, MOIXX, YOU TOO, DEVAS, EL, WRANGLER, THE CULT RENOV,
					NORTON, CHRISTIAN ARMAND, PIONIER, BABY INFANTI, COLLOKY, BUBBLE
					GUMMERS, TIENDAS MEYLIN, BABY CLUB, BIBI, ADIDAS, CAT, ADIDAS
					ORIGINALS, SKECHERS, CONVERSE, NEW ATHLETIC, WEINBRENNER, I-RUN, MAUI
					AND SONS, LIPPI, QUIKSILVER, FOOTLOSE, BATA, VIALE, PLATANITOS, BATA
					WOMAN, OJEDA, PAYLESS SHOES, CALIMOD, RENZO COSTA CALZADO, DC,
					AZALEIA, KELLYS SHOES, JETSET, HUSH PUPPIES, CROCS, TM ACCESORIOS, BE
					SIFRAH, ISADORA, MOIRAS, KAYSER, TEXTILON, RENZO COSTA, PORTA PRO,
					OCEANO MOCHILAS, TIZZA, QUALITY STORE, TAI LOY, GMO, VISION CENTER,
					ECONOPTICAS, SUNGLASS HUT, SUN TIME STORE, ESIKA, MIFARMA, INKAFARMA,
					CRISOL, LA IBERICA, PRO NUTRITION, HEALTH ONE, LEXUS KIDS, H&M,
					ESTILOS, CASA & IDEAS, TOPITOP, MAMUT MODULO, , PREMIER DEAD SEA,
					JOYERIA MUÑOZ NAJAR, VIVE MEXICO MODULO, MEGA PHONE MODULO, MAYBELLINE
					MODULO, CHRONOS MODULO, ARTEM COLLECTION, EF PERFUMES MODULO, MAC
					COSMETICOS, PERFUMES FACTORY, FRANCISCA F.O, RIPLEY, SAGA, SODIMAC.
				</p>
			</div>
			<b>II. ¿Cómo funciona EL SERVICIO?</b>
			<br/>
			<br/>
			<div class="text-justify mx-2">
				<p>A) Mecánica de EL SERVICIO</p>
				<p>El Usuario para hacer uso de EL SERVICIO deberá:</p>
				<ol>
					<li>
						Buscar el número de WhatsApp del MALL AVENTURA AREQUIPA 989047143.
						que se difundirá a través de la publicidad del MALL AVENTURA
						AREQUIPA.
					</li>
					<li>
						Enviar un mensaje al WhatsApp, a través de un teléfono inteligente,
						Tablet o laptop, a fin de ponerse en contacto con el “asesor de
						compras”, quien le solicitará identificarse.
					</li>
					<li>
						Brindar su nombre completo, su número de Documento de
						Identificación, correo electrónico y dirección en la cual se deberán
						entregar los productos adquiridos a través de EL SERVICIO.
					</li>
					<li>
						Aceptar los Términos y Condiciones de Uso de EL SERVICIO, a fin de
						que el “asesor de compras” solicite las especificaciones del
						producto que se desee comprar.
					</li>
					<li>
						Describir el producto a adquirir con el mayor detalle posible
						(identificación del producto, cantidad, rango de precios, marca o
						tienda de preferencia, talla, modelo y color -de ser el caso-,),
						pudiendo incluso adjuntar una foto o imagen referencial. Esta
						información permitirá al “asesor de compras” realizar la búsqueda
						del producto el mismo día de recibida la solicitud, siempre que la
						interacción se realice dentro del horario de EL SERVICIO.
					</li>
					<li>
						Escoger de las diferentes opciones que le sean proporcionadas por el
						“asesor de compras”, el producto a ser adquirido por encargo (se
						detallará el precio anunciado en tienda).
					</li>
					<li>
						Con esta información, el “asesor de compras” enviará al Usuario una
						cotización conteniendo: (i) el/los producto(s) escogido(s) y su(s)
						precio(s) y (ii) el costo del delivery según el destino.
					</li>
					<li>
						Brindar su conformidad a la cotización detallada por el “asesor de
						compras”. A continuación, éste le solicitará al Usuario realizar el
						depósito o transferencia del importe total antes indicado a
						cualquiera de las siguientes cuentas bancarias a titularidad de
						JTSM:
					</li>
					<ul>
						<li>Cuenta bancaria BCP No. 193-38650256061</li>
						<li>Cuenta bancaria BBVA No. 0011-08140202148927</li>
						<li>Cuenta bancara Interbank No. 108-3089285426</li>
						<li>Cuneta bancara Scotiabank No. 174-0184112</li>
					</ul>
					<li>
						Realizar el depósito o transferencia del importe total aceptado y
						enviar la constancia respectiva al “asesor de compras” a través de
						WhatsApp. Una vez validado el pago, el “asesor de compras” procederá
						a realizar la compra del/de los productos(s) confirmado(s).
					</li>
					<li>
						Autorizar el uso de sus datos personales y esperar la entrega de
						su(s) producto(s).
					</li>
				</ol>
				<p>B) Restricciones de EL SERVICIO</p>
				<p>EL SERVICIO NO se encuentra disponible para:</p>
				<ul>
					<li>Menores de 18 años de edad.</li>
					<li>
						La adquisición de productos congelados o que requieran
						refrigeración.
					</li>
					<li>
						La adquisición de compras que tengan un valor en total mayor a S/
						500.00 (Quinientos y 00/100 Soles).
					</li>
					<li>
						La adquisición de compras que tengan dimensiones mayores a 60 cm x
						60 cm x 60 cm o un peso mayor a 15 kg (ya sea las medidas y peso de
						un producto o de la suma de éstos, en ningún supuesto la compra
						podrá ser menor o mayor a dichos valores).
					</li>
					<li>
						Las siguientes zonas de delivery: Sabandia, Chiguata, Mollebaya,
						Horacio Cevallos, Yura, Tiabaya, Uchumayo.
					</li>
				</ul>
			</div>
			<b>III. Protección de Datos Personales</b>
			<br/>
			<br/>
			<div class="text-justify mx-2">
				<p>
					Se le informa que MALL AVENTURA AREQUIPA con domicilio para estos
					efectos en Jr. Minería N° 122, Piso 10, Santa Anita, Lima - Perú,
					realizará el tratamiento de sus datos personales los cuales serán
					almacenados en el banco de datos de “MEDIOS DIGITALES” con Registro N°
					12238 por un plazo indeterminado o hasta que decida revocar su
					consentimiento.
				</p>
				<p>
					MALL AVENTURA AREQUIPA tratará sus datos personales para las
					siguientes finalidades principales:
				</p>
				<ol>
					<li>
						Procesar su pedido y cumplir con los presente términos y
						condiciones.
					</li>
					<li>
						Establecer un canal de comunicación con MALL AVENTURA AREQUIPA para
						informarle respecto del envío del producto adquirido.
					</li>
					<li>
						Incorpóralo en el registro de MALL AVENTURA AREQUIPA para fines
						estadísticos e históricos.
					</li>
					<li>
						Establecer un medio de comunicación para atender sus consultas,
						preguntas, quejas, reclamos.
					</li>
				</ol>
				<p>
					Se le comunica que MALL AVENTURA AREQUIPA podrá compartir y encargar
					el tratamiento de sus datos personales a organización o personas
					directamente relacionadas, empresas prestadoras de servicios en la
					nube y empresas dedicadas a la publicidad o marketing. En estos casos,
					MALL AVENTURA AREQUIPA se compromete a informar el detalle de estos
					terceros a su correo electrónico.
				</p>
				<p>
					Se deja constancia que: (ii) su autorización es necesaria para el
					cumplimiento de las medidas antes mencionadas; y, (iii) podrá ejercer
					los derechos previstos en la Ley N° 29733, dirigiendo una solicitud al
					domicilio fiscal de MALL AVENTURA AREQUIPA con el asunto "Derechos
					Datos Personales".
				</p>
				<p>
					En caso, considere que no ha sido atendido, podrá presentar una
					reclamación ante la Autoridad Nacional de Protección de Datos
					Personales, dirigiéndose a la Mesa de Partes del Ministerio de
					Justicia y Derechos Humanos ubicado en Calle Scipión Llona N° 350,
					Miraflores, Lima, Perú.
				</p>
			</div>
			<b>IV. Consideraciones Finales</b>
			<br/>
			<br/>
			<div class="text-justify mx-2">
				<ul>
					<li>
						El Usuario tiene conocimiento que deberá realizar la cancelación del
						íntegro del importe indicado por el “asesor de compras” mediante el
						WhatsApp de MALL AVENTURA AREQUIPA para poder completar su solicitud
						correspondiente a EL SERVICIO.
					</li>
					<li>
						No existirá un tiempo máximo en que el Usuario deberá realizar el
						depósito o la transferencia; no obstante, no se podrá asegurar la
						disponibilidad del/de los producto(s) acordados en caso el depósito
						o transferencia se realice en un tiempo mayor a 15 minutos.
					</li>
					<li>
						El “asesor de compras” realizará la búsqueda del producto de acuerdo
						al requerimiento de los Usuarios; no obstante, de ninguna manera
						puede garantizar que al momento en que se vaya a realizar la compra
						del producto éste se encuentre disponible, ya que ello depende
						exclusivamente de cada tienda ubicada en MALL AVENTURA AREQUIPA.
					</li>
					<li>
						El producto siempre será entregado al Usuario con su respectivo
						comprobante de pago, emitido por la tienda donde haya sido
						adquirido. Se recomienda guardar el comprobante de pago en caso de
						cambios o devoluciones que se tengan que realizar con la misma
						tienda/marca.
					</li>
					<li>
						El usuario entiende que MALL AVENTURA S.A. y JSM actúan como meros
						intermediarios de la compra. Por ello, ante cualquier cambio,
						devolución o reclamo (que no sea deba al delivery) por parte del
						Usuario sobre el producto recibido (por talla, modelo, color,
						características etc.), el Usuario deberá contactarse directamente
						con la tienda/marca para realizar esa solicitud. El Usuario está
						sujeto a la política de cambios y devoluciones de cada
						establecimiento.
					</li>
					<li>
						El Usuario no se encuentra obligado a comprar y/o cancelar el
						producto pese a haber utilizado los servicios de la “asesor de
						compras”.
					</li>
					<li>
						El Usuario podrá solicitar EL SERVICIO cuantas veces y por el tiempo
						que lo requiera, y no existirá un número mínimo, ni máximo de
						pedidos, ni de tiendas a visitar; no obstante, en caso los
						requerimientos del Usuario generen una alta demanda en EL SERVICIO,
						entonces el “asesor de compras” podrá limitar el tiempo de la
						interacción con el Usuario, así como establecer un número mínimo o
						máximo de pedidos o de visitas a tiendas por cada Usuario.
					</li>
					<li>
						El Usuario tiene conocimiento que tendrá la opción de realizar el
						pago del producto una vez que el “asesor de compras” culmine la
						búsqueda en la tienda que visite, con el objetivo de asegurar su
						compra. En caso a solicitud del Usuario, el “asesor de compras”
						visite más de un tienda, el Usuario podrá realizar el pago al
						término de la búsqueda realizada en todas las tiendas visitadas por
						el “asesor de compras”, quien no será responsable de la
						disponibilidad de éstos al momento del retorno a la tienda.
					</li>
					<li>
						En caso el Usuario quiera realizar compras en más de una tienda,
						entonces, para asegurar la compra, deberá pagar en cada tienda, de
						forma inmediata a que conforme el producto. Por ejemplo, si compra 3
						productos de 3 tiendas diferentes, deberá pagar 3 veces.
					</li>
					<li>
						MALL AVENTURA S.A. no será responsable por los daños que puedan
						ocasionarse a los productos durante el traslado de los mismo al
						domicilio indicado por el Usuario, siendo ello de responsabilidad
						absoluta de JSM.
					</li>
					<li>
						JSM es responsable del extorno del dinero por cualquier pedido no
						entregado adecuadamente (por robo, pérdida, rotura u otro), siempre
						que la responsabilidad sea directamente de JSM. Esta solicitud del
						extorno del dinero deberá ser solicitada por parte del Usuario al
						“asesor de compras” vía WhatsApp.
					</li>
					<li>
						El extorno del dinero por parte de JSM se realizará en un plazo
						máximo de tres (3) días hábiles.
					</li>
					<li>
						Si el vehículo de taxi , una vez que se encuentre en el domicilio
						que indique el Usuario, no es atendido en un rango de quince (15)
						minutos o si el domicilio no fuese encontrado por error en las
						indicaciones, entonces el vehículo de taxi regresará a MALL AVENTURA
						AREQUIPA.<br/>
						En ese supuesto, se deberá reprogramar el delivery, cobrándole
						también al Usuario el costo por el delivery reprogramado. La fecha
						de reprogramación del delivery será a discrecionalidad de JSM.
					</li>
					<li>
						Libro de Reclamaciones Virtual de MALL AVENTURA S.A., disponible en:
						https://mallaventura.pe/porongoche/libro-de-reclamaciones/
					</li>
					<li>
						Se entiende que, al usar EL SERVICIO, el Usuario ha leído y acepta
						los términos y condiciones de uso, así como el uso de sus datos
						personales.
					</li>
				</ul>
				<br/>
			</div>
			<br/>
		</div>
		<footer class="blog-footer bg-dark">
			<div class="container pt-2 text-left">
				<a href="https://www.mallaventura.com">
					<img src="@/assets/logo.png"
   						width="100px"
   						alt />
				</a>
				<br/>
				<br/>
				<div class="row text-white m-0">
					<div class="col-md-8 col-12 p-0">
						<div class="row">
							<h6 class="font-weight-light ml-3">Dirección:</h6>
							<h6 class="font-weight-semibold ml-3">
								Av. Nicolas Ayllón 15008, Santa Anita
							</h6>
						</div>
						<br/>
						<div class="row ml-1">
							<ion-icon class="txt_verde ion-icon"
        								name="logo-whatsapp" />
							&nbsp;&nbsp;&nbsp;
							<h6 class="mt-2 ml-2 txt_wp">51 926 726 307</h6>
						</div>
						<br/>
						<div class="row ml-1">
							<h6 class="font-weight-light">Síguenos en:</h6>
							&nbsp;&nbsp;&nbsp;
							<a href="https://www.facebook.com/mallaventura/"
 								class="text-white ml-2"
 								>
								<ion-icon name="logo-facebook"
        									class="ion-icon" />
							</a>
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
							<a href="https://www.instagram.com/mall.aventura/"
 								class="text-white ml-2"
 								>
								<ion-icon name="logo-instagram"
        									class="ion-icon" />
							</a>
						</div>
					</div>
					<div class="col-md-4 col-12 p-0 m-0">
						<h6>Protocolo de prevención del COVID-19</h6>
						<router-link class="text-white  "
           							to="/Terminos&condiciones">
							<button color="white"
      								flat value="Términos y condiciones">
								<span class="text-white">Términos y condiciones</span>
							</button>
						</router-link>
						<h6>Políticas de privacidad</h6>
					</div>
				</div>
			</div>
			<div class="bg-black text-white text-center p-2">Mall Aventura 2020</div>
		</footer>
	</div>
</template>
<script>
	export default {};
</script>
